<template>
    <div class="card">
        <div class="card-header">Nouvelle tâche</div>
        <div class="card-body">
            <task-create />
        </div>
    </div>
</template>

<script>
import TaskCreate from '../../clients/components/tasks/CreateWithoutClient.vue'

export default {
    name: 'NewTask',
    components: { TaskCreate },
}
</script>

<style scoped></style>
